<template>
  <main class="terms pad grid gap c-2 orange">
    <div>
      <div class="fixheight">
        <clock />
      </div>
    </div>
    <div class="privacy-text" v-if="terms.text">
      <div v-html="terms.text"></div>
    </div>
    <div class="sub-links pad-txt">
      <router-link :to="{ name: 'about' }" class="marker">About</router-link>
      <router-link :to="{ name: 'channels' }" class="marker"
        >Channels</router-link
      >
      <router-link :to="{ name: 'policies' }" class="marker"
        >Policies</router-link
      >
      <router-link :to="{ name: 'terms' }" class="marker active"
        >Terms</router-link
      >
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
const Clock = () =>
  import(/* webpackChunkName: "Clock" */ "@/components/Clock.vue");
export default {
  name: "Terms",
  components: {
    Clock
  },
  metaInfo() {
    return {
      title: "– Terms and Conditions"
    };
  },
  computed: mapState(["terms"])
};
</script>

<style lang="scss">
.indent {
  display: grid;
  grid-template-columns: calc(2 * var(--lh)) auto;
  margin-bottom: 0;
}
.terms {
  background: var(--orange) !important;
  .privacy-text {
    > div:not(:last-of-type) {
      margin-bottom: var(--lh);
      &.no-mar {
        margin-bottom: 0;
      }
    }
    ul {
      list-style-type: disc;
      padding-left: 20px;
    }
    p {
      margin-bottom: 0px;
    }
    p + p {
      margin-top: 20px;
    }
    p + ul {
      margin-bottom: 20px;
    }
  }
  .fixheight {
    position: sticky;
    top: 50%;
    display: inline-block;
    height: auto;
    width: 100%;
    transform: translate(0, -50%);
    @media only screen and (max-width: 768px) {
      position: relative;
      width: 100%;
      height: 50vh;
      transform: none;
      top: 0%;
    }
  }
}
</style>
